import {
  COLOR_VARIANTS,
  Icons,
  TYPOGRAPHY_VARIANT,
  Typography,
  Tooltip,
} from "@tajawal/ct-web-design-system";
import Styled from "./Airport.styled";
import { LOCATION_TYPES } from "@tajawal/web-flights-sdk/lib/constants";
import TrainIcon from "@/assets/images/train.svg";
import { useTranslation } from "react-i18next";
import { getAirportTitle } from "@/utils/content.utils";
import Image from "@/app-common/components/Image";

export type AirportProps = {
  type: string;
  name: string;
  isNearbyAirport: boolean;
  testId: string;
  isReturnFlight?: boolean;
  resources: any;
};

const highLightMap = {
  [LOCATION_TYPES.AIRPORT]: {
    color: COLOR_VARIANTS.WHITE,
    icon: null,
  },
  [LOCATION_TYPES.BUS]: {
    color: COLOR_VARIANTS.BUTTERCUP10,
    icon: Icons.Bus,
  },
  [LOCATION_TYPES.TRAIN]: {
    color: COLOR_VARIANTS.BUTTERCUP10,
    icon: TrainIcon.src,
  },
  [LOCATION_TYPES.CITY]: {
    color: COLOR_VARIANTS.WHITE,
    icon: null,
  },
};

function Airport({
  type,
  isNearbyAirport,
  name,
  testId,
  isReturnFlight = false,
  resources,
}: AirportProps): JSX.Element {
  const { t } = useTranslation();

  const isBus = type === LOCATION_TYPES.BUS;
  const Icon = highLightMap[type]?.icon;
  let highlightColor = highLightMap[type]?.color || COLOR_VARIANTS.WHITE;
  if (!isBus && isNearbyAirport) {
    highlightColor = COLOR_VARIANTS.BUTTERCUP100;
  }
  const airportTooltip = getAirportTitle(name, type, resources, t);

  return (
    <Styled.AirportWrapper $isReturnFlight={isReturnFlight}>
      <Tooltip
        title={
          <Styled.AirportTooltipContent>
            <Typography
              variant={TYPOGRAPHY_VARIANT.BODY2}
              align="center"
              component="p"
              color={COLOR_VARIANTS.WHITE}
            >
              {airportTooltip}
            </Typography>
          </Styled.AirportTooltipContent>
        }
        placement="top"
      >
        <Styled.AirportName $highlightColor={highlightColor}>
          {Icon && type === LOCATION_TYPES.TRAIN && (
            <Image src={TrainIcon} width="16px" height="16px" />
          )}
          {Icon && type !== LOCATION_TYPES.TRAIN && (
            <Icon width="16" height="16" />
          )}
          <Typography
            testId={testId}
            component="span"
            variant={TYPOGRAPHY_VARIANT.CAPTIONREG}
          >
            {name}
          </Typography>
        </Styled.AirportName>
      </Tooltip>
    </Styled.AirportWrapper>
  );
}

export default Airport;
